// extracted by mini-css-extract-plugin
export default {"container":"cdF9h","triangle":"xkQHp","right":"VOYWo","left":"sYAZJ","bottom":"peMLb"};